import { selectIn } from 'common/util/selector'

const base = (state, props) => state.main.settings.custom_roles

export const filterValues = selectIn(base, 'filter_values')
export const roles = selectIn(base, 'list')
export const rolesLoading = selectIn(base, 'list_loading')
export const rolesTotal = selectIn(base, 'count')
export const createRoleLoading = selectIn(base, 'create_loading')
